<template>
  <v-template>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text class="py-0">
        <v-row no-gutters>
          <v-col>
            <CustomTextField
              v-model="title"
              label="Найменування"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="content"
              outlined
              label="Опис проекта"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </v-template>
</template>

<script>
import * as projectApi from "../../backend/projectsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    errorException: "",
    isChanged: false,
    content: "",
    title: "",
    logTime: "",
    description: "",
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.title.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення проекта" : "Редагування проекта";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_DATE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_REASON: [ERRORS.REQUIRED],
        CRM: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      projectApi.getProject(this.id).then((issue) => {
        this.title = issue.title;
        this.content = issue.description;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;
      if (this.id == 0) {
        await projectApi
          .createProject({ title: this.title, description: this.content })
          .then(() => {
            this.$router.push({ path: "/projects-projects" });
          });
      } else {
        await projectApi.updateProject(this.id, {
          title: this.title,
          description: this.content,
        });
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>